import { MutationTree } from 'vuex';
import { RoleState } from './state';

const mutations: MutationTree<RoleState> = {
  SET_ROLES(state, entities: RoleState) {
    state.roles = entities.roles;
  },
};

export default mutations;
